import React from 'react';
import {
  NewOrderQuantityStoreProvider,
  useNewOrderQuantityStore,
} from '@/stores/new-order-quantity-store';
import { QuantityReducerAction } from '@/screens/new-order/hooks/use-quantity-reducer';

/*
 * Thin aliases over the Zustand quantity store (see
 * stores/new-order-quantity-store.tsx). The dispatch hook and provider keep
 * their original names so the call sites that set up and dispatch into the
 * store didn't all need to change when quantity state moved out of React
 * context.
 *
 * To read quantity state, use the selector hooks in the store module
 * (useItemVisibleQuantity / useItemQuantityState / useHasAnyItemQuantity) or,
 * for the whole map, useNewOrderQuantityStore directly — don't reach for a
 * whole-state read unless you genuinely need every item.
 */

export const useNewOrderQuantityStateDispatchContext =
  (): React.Dispatch<QuantityReducerAction> =>
    useNewOrderQuantityStore((s) => s.dispatch);

export const NewOrderQuantityStateContextProvider =
  NewOrderQuantityStoreProvider;
